import React, { Fragment, useState, useEffect } from "react";
import { Row, Col, Form, Button, Toast } from "react-bootstrap";
import { IoIosClose, IoMdDownload } from "react-icons/io";
import ReactTable from "../../../../components/FilterTable";
import { _HttpServices } from "../../../../_services/_HttpServices";
import Loader from "../../../../components/Loader";
import moment from "moment";
import { useHistory } from "react-router";
import getExcel from "../../../../_services/ExcelUtility";
import { Footer } from "../../../../components/Footer";

const GenentechChargebacks = () => {
	const fileName = "Chargeback Source Data 844 (EDI)";
	const outbounddata = JSON.parse(localStorage.getItem("outboundreport"));
	const userData = JSON.parse(localStorage.getItem("userData"));
	const history = useHistory();
	const [chargeback, setChargeback] = useState([]);
	const [rejectedChargebacks, setRejectedChargebacks] = useState([]);
	const [loading, setLoading] = useState(false);
	const [hasError, setHasError] = useState(false);
	const columns = [
		{
			Header: "Distributor Name",
			accessor: "DistributorName",
			filter: "DistributorName",
			sortType: "basic",
		},
		{
			Header: "Distributor HIN #",
			accessor: "DistributorHIN",
			filter: "DistributorHIN",
			sortType: "basic",
		},
		{
			Header: "Debit Memo/Document #",
			accessor: "DebitMemo",
			filter: "DebitMemo",
			sortType: "basic",
		},
		{
			Header: "Total line count",
			accessor: "TotalLineCount",
			filter: "TotalLineCount",
			sortType: "basic",
		},
		{
			Header: "Total Amount Requested",
			accessor: "TotalAmountRequested",
			filter: "TotalAmountRequested",
			sortType: "basic",
		},
		{
			Header: "340B ID/ HIN",
			accessor: "HIN",
			filter: "HIN",
			sortType: "basic",
		},
		{
			Header: "Invoice Date",
			accessor: "InvoiceDate",
			filter: "InvoiceDate",
			sortType: "basic",
			width: 110,
			filterMethod: (filter, row) => {
				const rowValue = row.original;
				return rowValue.datefiled.includes(filter.value);
			},
		},
		{
			Header: "Invoice #",
			accessor: "InvoiceID",
			filter: "InvoiceID",
			sortType: "basic",
			width: 90,
		},
		{
			Header: "Product NDC-11",
			accessor: "ProductNDC",
			filter: "ProductNDC",
			sortType: "basic",
			width: 130,
		},
		{
			Header: "Product Description",
			accessor: "ProductDescription",
			filter: "ProductDescription",
			sortType: "basic",
		},
		{
			Header: "Contract ID #",
			accessor: "ContractID",
			filter: "ContractID",
			sortType: "basic",
			width: 120,
		},
		{
			Header: "Qty",
			accessor: "Quantity",
			filter: "Quantity",
			sortType: "basic",
			width: 80,
		},
		{
			Header: "Orig WAC Price Per Pkg",
			accessor: "OrigWACPricePerPkg",
			filter: "OrigWACPricePerPkg",
			sortType: "basic",
		},
		{
			Header: "Contract Price Per Pkg",
			accessor: "ContractPricePerPkg",
			filter: "ContractPricePerPkg",
			sortType: "basic",
		},
		{
			Header: "Chargeback Amount (Ext Total)",
			accessor: "ChargebackAmount",
			filter: "ChargebackAmount",
			sortType: "basic",
		},
		{
			Header: "Total Amount Claimed",
			accessor: "TotalAmountClaimed",
			filter: "TotalAmountClaimed",
			sortType: "TotalAmountClaimed",
		},
	];

	useEffect(() => {
		getChargeback();
		getRejectedChargeback();
	}, []);

	async function getChargeback() {
		setLoading(true);
		let url = `api/Inbound/OutboundReportsData?FileProcessID=${outbounddata.FileProcessID}&ServiceTaskID=${outbounddata.ServiceTaskID}&FileTypeCode=ChargebacksWeekly&TaskTypeCode=GenentechChargebacks&FileFormat=${outbounddata.FileFormat}`;
		await _HttpServices
			.getData(url)
			.then((data) => {
				const chargebackResult = data.data;
				if (chargebackResult.length > 0) {
					let ind = 1;
					chargebackResult.map((res) => {
						res.InvoiceDate = moment(res.InvoiceDate).format("MM/DD/YYYY");
						res.ind = ind++;
					});
				}
				setChargeback(chargebackResult);
				setLoading(false);
			})
			.catch((e) => {
				setLoading(false);
				setHasError(true);
			});
	}

	async function getRejectedChargeback() {
		let url = `api/Inbound/Get849OutboundReportsData?FileProcessID=${outbounddata.FileProcessID}&ServiceTaskID=${outbounddata.ServiceTaskID}&FileTypeCode=ChargebacksWeekly&TaskTypeCode=GenentechChargebacks&FileFormat=${outbounddata.FileFormat}`;
		if (
			userData.RoleID === 1 &&
			outbounddata.Version_File === 0 &&
			(outbounddata.FileSentStatus === "Sent" ||
				outbounddata.FileSentStatus === "Rejected") &&
			outbounddata.ServiceTaskID === 575 &&
			outbounddata.Isrejected
		) {
			setLoading(true);
			await _HttpServices
				.getData(url)
				.then((data) => {
					const rejectedChargebacksResult = data.data;
					if (rejectedChargebacksResult.length > 0) {
						let ind = 1;
						rejectedChargebacksResult.map((res) => {
							res.InvoiceDate = moment(res.InvoiceDate).format("MM/DD/YYYY");
							res.ind = ind++;
						});
					}
					setRejectedChargebacks(rejectedChargebacksResult);
					setLoading(false);
				})
				.catch((e) => {
					setLoading(false);
				});
		}
	}

	const EditRecords = () => {
		if (
			userData.RoleID === 1 &&
			outbounddata.Version_File === 0 &&
			(outbounddata.FileSentStatus === "Sent" ||
				outbounddata.FileSentStatus === "Rejected") &&
			outbounddata.ServiceTaskID === 575 &&
			outbounddata.Isrejected
		) {
			localStorage.setItem("chargeback", JSON.stringify(rejectedChargebacks));
		} else {
			localStorage.setItem("chargeback", JSON.stringify(chargeback));
		}
		history.push("/ChargebackAddEdit");
	};

	return (
		<section className="content">
			<div className="page-title">
				<h2 className="h2">Genentech Chargeback Source Data</h2>
				{loading ? <Loader /> : null}
				<div>
					{chargeback.length > 0 &&
						userData.RoleID === 1 &&
						outbounddata.Version_File === 0 &&
						(outbounddata.FileSentStatus === "Sent" ||
						outbounddata.FileSentStatus === "Rejected" ? (
							outbounddata.ServiceTaskID === 575 && outbounddata.Isrejected ? (
								<Button type="submit" onClick={() => EditRecords()}>
									Create Reversal
								</Button>
							) : null
						) : (
							<Button type="submit" onClick={() => EditRecords()}>
								Edit Records
							</Button>
						))}

					<Button
						type="submit"
						className="ml-2"
						onClick={() => getExcel(columns, chargeback, fileName)}
					>
						<IoMdDownload className="icon btn-icon" />
						Download Excel{" "}
					</Button>
				</div>
			</div>
			<Row>
				<Col md={12}>
					<div className="card pt-2">
						<div className="card-body">
							<div className="inventory-grid">
								{hasError ? (
									<p>
										Error occurred. Unable to load Genentech Chargeback Source
										Data.
									</p>
								) : (
									<Fragment>
										{chargeback.length > 0 ? (
											<ReactTable
												columns={columns}
												data={chargeback}
												defaultPageSize={10}
											/>
										) : (
											<div className="no-data">No data found.</div>
										)}
									</Fragment>
								)}
							</div>
						</div>
					</div>
				</Col>
			</Row>
			<Row>
				<Col md={12} className="text-right mt-2">
					<Button
						variant="danger"
						type="button"
						className="ml-3"
						onClick={() => history.goBack()}
					>
						<IoIosClose className="icon btn-icon" />
						Cancel
					</Button>
				</Col>
			</Row>
			<Footer />
		</section>
	);
};

export default GenentechChargebacks;
